import { render } from "./supliersSkelton.vue?vue&type=template&id=4122fe54"
import script from "./supliersSkelton.vue?vue&type=script&lang=js"
export * from "./supliersSkelton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__